export default {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_STATUS_FILTER(state, status) {
    state.statusFilter = status;
  },
};
